export default "/images/nav-menu-icon.png?d8410a0f388b09ef80b5e4f922c5235b";